import type {TriggerIntegrationSpec, UnverifiedTriggerStruct} from '@cohort/shared/apps/trigger';
import {UnverifiedTriggerBaseConfigSchema} from '@cohort/shared/apps/trigger';
import {z} from 'zod';

const TikTokCommentTiktokTriggerConfigSchema = UnverifiedTriggerBaseConfigSchema.extend({
  videoId: z.string().min(1, 'errorRequired'),
});
type TikTokCommentTiktokTriggerConfig = z.infer<typeof TikTokCommentTiktokTriggerConfigSchema>;

const TikTokCommentTiktokVerificationAttemptDataSchema = z.object({
  username: z.string(),
  url: z.string().url(),
});
export type TikTokCommentTiktokVerificationAttemptData = z.infer<
  typeof TikTokCommentTiktokVerificationAttemptDataSchema
>;

export type TikTokCommentTiktokTriggerStruct = UnverifiedTriggerStruct<
  'tiktok.comment-tiktok',
  TikTokCommentTiktokTriggerConfig,
  TikTokCommentTiktokVerificationAttemptData
>;
export const TikTokCommentTiktokTriggerSpec: TriggerIntegrationSpec<TikTokCommentTiktokTriggerStruct> =
  {
    id: 'tiktok.comment-tiktok' as const,
    configurableMaxAttempts: false,
    configSchema: TikTokCommentTiktokTriggerConfigSchema,
    verificationAttemptDataSchema: TikTokCommentTiktokVerificationAttemptDataSchema,
    verificationAttemptInputSchema: z.object({}),
    requiresMerchantConnection: true,
    useCases: ['social-media'],
  };
